export { default } from './CGMAlertsModule';
